import { clsx } from "clsx";
import type { MpzpCoverageStatus } from "../../types";

/**
 * Znacznik pokrycia planem miejscowym. CZTERY stany w czterech kolorach — „brak planu"
 * i „nie wiadomo" celowo NIE wyglądają tak samo: pierwsze to fakt, drugie to luka w
 * krajowym rejestrze, i tylko pierwsze jest powodem, żeby się zastanawiać nad zamówieniem.
 */
const STYLES: Record<MpzpCoverageStatus, string> = {
  covered: "bg-green-50 text-green-800 border-green-300",
  none: "bg-red-50 text-red-800 border-red-300",
  unknown: "bg-amber-50 text-amber-800 border-amber-300",
  unchecked: "bg-[var(--color-bg-elevated)] text-[var(--color-text-muted)] border-[var(--color-border)]",
};

const SHORT: Record<MpzpCoverageStatus, string> = {
  covered: "MPZP",
  none: "brak planu",
  unknown: "nie wiadomo",
  unchecked: "nie sprawdzono",
};

export function MpzpCoverageBadge({
  status,
  label,
  coveredPct,
}: {
  status: MpzpCoverageStatus;
  label?: string;
  coveredPct?: number | null;
}) {
  const title =
    status === "covered" && coveredPct != null
      ? `${label ?? SHORT[status]} — pokrycie ${coveredPct.toFixed(0)}% powierzchni działki`
      : label;
  return (
    <span
      className={clsx(
        "inline-block px-1.5 py-0.5 text-[10px] font-mono uppercase tracking-wide border whitespace-nowrap",
        STYLES[status] ?? STYLES.unchecked,
      )}
      title={title}
    >
      {SHORT[status] ?? status}
    </span>
  );
}
